export default __webpack_public_path__ + "static/media/co5.a7d25226.png";